/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowADownLeftIcon16Light } from './ArrowADownLeftIcon16Light';
import { ArrowADownLeftIcon16Regular } from './ArrowADownLeftIcon16Regular';
import { ArrowADownLeftIcon16Solid } from './ArrowADownLeftIcon16Solid';
import { ArrowADownLeftIcon20Light } from './ArrowADownLeftIcon20Light';
import { ArrowADownLeftIcon20Regular } from './ArrowADownLeftIcon20Regular';
import { ArrowADownLeftIcon20Solid } from './ArrowADownLeftIcon20Solid';
import { ArrowADownLeftIcon24Regular } from './ArrowADownLeftIcon24Regular';
import { ArrowADownLeftIcon24Solid } from './ArrowADownLeftIcon24Solid';
import { ArrowADownLeftIcon32Regular } from './ArrowADownLeftIcon32Regular';
import { ArrowADownLeftIcon64Regular } from './ArrowADownLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowADownLeftIcon16Light,
        regular: ArrowADownLeftIcon16Regular,
        solid: ArrowADownLeftIcon16Solid,
    },
    20: {
        light: ArrowADownLeftIcon20Light,
        regular: ArrowADownLeftIcon20Regular,
        solid: ArrowADownLeftIcon20Solid,
    },
    24: {
        regular: ArrowADownLeftIcon24Regular,
        solid: ArrowADownLeftIcon24Solid,
    },
    32: {
        regular: ArrowADownLeftIcon32Regular,
    },
    64: {
        regular: ArrowADownLeftIcon64Regular,
    },
};
export var ArrowADownLeftIcon = forwardRef('ArrowADownLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
